import { withSvgIcon } from './withSvgIcon';

export const Stats = withSvgIcon(
  <path
    clipRule="evenodd"
    d="M13 2.25C12.0335 2.25 11.25 3.0335 11.25 4V4.75001L9 4.75C8.0335 4.75 7.25 5.5335 7.25 6.5V8.75L5 8.75C4.0335 8.75 3.25 9.5335 3.25 10.5V16C3.25 16.9665 4.0335 17.75 5 17.75H7.25H8H8.75H11.25H12H12.75H15C15.9665 17.75 16.75 16.9665 16.75 16V4.00001C16.75 3.03351 15.9665 2.25001 15 2.25001L13 2.25ZM12.75 16.25H15C15.1381 16.25 15.25 16.1381 15.25 16V4.00001C15.25 3.86194 15.1381 3.75001 15 3.75001L13 3.75C12.8619 3.75 12.75 3.86193 12.75 4V4.75001V5.50001V16.25ZM11.25 16.25V6.25001L9 6.25C8.86193 6.25 8.75 6.36193 8.75 6.5V8.75001V9.5V16.25H11.25ZM7.25 10.25V16.25H5C4.86193 16.25 4.75 16.1381 4.75 16V10.5C4.75 10.3619 4.86193 10.25 5 10.25L7.25 10.25Z"
    fill="currentColor"
    fillRule="evenodd"
  />,
  { viewBox: '0 0 20 20' },
);
